<template>
    <f7-page
        name="Get the app"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="Get the app"
            inner-class="onboardingBg"
        >
            <f7-nav-title>Get the app</f7-nav-title>
        </f7-navbar>

        <f7-block style="background: white; color: black;">
            <br>
            <img
                src="../../img/icon.png"
                style="width: 60px; border-radius: 8px; box-shadow: 1px 1px rgba(0,0,0,0.5);"
            >
            <br>
            <br>
            The app version of Coral is much better.<br>Get it now!<br><br>
            <a href="https://apps.apple.com/us/app/coral-improved-intimacy/id1448861466">
                <img
                    src="https://getcoral.app/home/images/app-store.svg"
                    style="width: 160px"
                    alt="Apple AppStore"
                    class="external"
                >
            </a>
            <a href="https://play.google.com/store/apps/details?id=app.getcoral.m">
                <img
                    src="https://getcoral.app/home/images/google-store.svg"
                    style="width: 160px"
                    alt="Google Play"
                    class="external"
                >
            </a>
            <br> <br> <br>
        </f7-block>
        <div class="exploreContentSectionWave" />
        <f7-button
            :color="'gray'"
            style="margin-top: -40px"
            back
            fill
            round
        >NOT NOW</f7-button>
        <f7-block />
    </f7-page>
</template>

<script>
export default {
    store: ['api'],
    data () {
        return {
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.exploreContentSectionWave {
    margin-top: -35px;
    padding-top: 0px;
    width: 100%;
    min-height: 100px;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: @darkBackground;
    background-image: url('../../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
}
</style>
